import { lazy, Suspense, useEffect, useState } from "react";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { WhyUs } from "@/components/site/WhyUs";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFab } from "@/components/site/WhatsAppFab";
import Gallery from "@/components/site/Gallery";

// Below-the-fold sections — code-split for faster initial paint
const Testimonials = lazy(() => import("@/components/site/Testimonials"));
const BookingForm = lazy(() => import("@/components/site/BookingForm"));

const Index = () => {
  const [loadDeferredSections, setLoadDeferredSections] = useState(false);

  useEffect(() => {
    document.title = "Gurpreet Refrigeration — AC, Fridge, RO & Washing Machine Repair in Mansa";
    const desc = "Expert home appliance repair in Mansa. Same-day AC, washing machine, RO and fridge service. Call 8968170459.";
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) { meta = document.createElement("meta"); meta.setAttribute("name", "description"); document.head.appendChild(meta); }
    meta.setAttribute("content", desc);
  }, []);

  useEffect(() => {
    const win = window as Window & {
      requestIdleCallback?: (callback: IdleRequestCallback, options?: IdleRequestOptions) => number;
      cancelIdleCallback?: (handle: number) => void;
    };
    const idle = win.requestIdleCallback
      ? win.requestIdleCallback(() => setLoadDeferredSections(true), { timeout: 1800 })
      : globalThis.setTimeout(() => setLoadDeferredSections(true), 1200);

    return () => {
      if (win.cancelIdleCallback) win.cancelIdleCallback(idle as number);
      else globalThis.clearTimeout(idle);
    };
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <Hero />
        <Services />
        <Gallery />
        <WhyUs />
        {loadDeferredSections && <Suspense fallback={null}><Testimonials /></Suspense>}
        {loadDeferredSections && <Suspense fallback={null}><BookingForm /></Suspense>}
        <section id="contact" className="py-16 bg-gradient-hero text-primary-foreground">
          <div className="container text-center">
            <h2 className="text-3xl md:text-4xl text-primary-foreground">Need help right now?</h2>
            <p className="mt-3 opacity-90">Call us directly — we're available during shop hours.</p>
            <a href="tel:8968170459" className="mt-6 inline-block rounded-xl bg-accent px-8 py-4 text-lg font-bold text-accent-foreground shadow-glow hover:scale-105 transition-smooth">
              📞 Call 8968170459
            </a>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
};

export default Index;
